<template>
	<div id="footer">
		<div class="mainbox">
			<div class="column">
				<div>
					<div style="font-size: 14px;color: white;line-height: 25px;">
						<span @click="toAboutUs()" style="padding-right: 10px;border-right: 1px solid white;">关于我们</span>
						<span @click="toHehuaCulture()" style="padding-right: 10px;border-right: 1px solid white;padding-left: 10px;">和华文化</span>
						<span @click="toBusinessArea()" style="padding-right: 10px;border-right: 1px solid white;padding-left: 10px;">业务领域</span>
						<span @click="toProfessional()" style="padding-right: 10px;border-right: 1px solid white;padding-left: 10px;">专业人员</span>
						<span @click="toNews()" style="padding-right: 10px;border-right: 1px solid white;padding-left: 10px;">资讯动态</span>
						<span @click="toContactUs()" style="padding-right: 10px;border-right: 1px solid white;padding-left: 10px;">联系我们</span>
						<span @click="toDisclaimer()" style="padding-right: 10px;border-right: 1px solid white;padding-left: 10px;">免责条款</span>
						<span @click="toPrivacyPolicy()" style="padding-right: 10px;padding-left: 10px;">隐私政策</span>
					</div>
				</div>
			</div>
			<div class="qrcode">
				<div class="wechat">
					<img src="../../assets/fImage/qrcode.jpg">
				</div>
			</div>
		</div>
		<div class="tipbox">
			<div>北京和合网链科技发展有限公司</div>
			<div>Shanghaihehualisheng tech co.,Ltd e-mail</div>
			<div><a class="link" style="color:#8D8D8D;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2021040024号</a></div>
		</div>
	</div>
</template>

<script>
	import {queryByPos,queryIndexByPos} from "../../api/front.js"
	export default {
		name: "Footer",
		data() {
			return {
				channels: [],
			}
		},
		mounted() {
			queryIndexByPos('nav').then(data => {
				this.channels = data.data
			}).catch(error => {
			
			})
		},
		methods:{
			toAboutUs(){
				this.$router.push(
					{
						path:'/phone/aboutUs'
					}
				);
			},
			toHehuaCulture(){
				this.$router.push(
					{
						path:'/phone/hehuaCulture'
					}
				);
			},
			toBusinessArea(){
				this.$router.push(
					{
						path:'/phone/businessArea'
					}
				);
			},
			toProfessional(){
				this.$router.push(
					{
						path:'/phone/professional'
					}
				);
			},
			toNews(){
				this.$router.push(
					{
						path:'/phone/news'
					}
				);
			},
			toContactUs(){
				this.$router.push(
					{
						path:'/phone/contactUs'
					}
				);
			},
			toDisclaimer(){
				this.$router.push(
					{
						path:'/phone/disclaimer'
					}
				);
			},
			toPrivacyPolicy(){
				this.$router.push(
					{
						path:'/phone/privacyPolicy'
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	a{
		color: #FFFFFF;
		text-decoration: none;
	}
	a:hover {  
		color : #1a86ff ; 
	}
	#footer {
		height: 250px;
    width: 100%;
    background-color: #202020;
    color: #FFFFFF;
    font-family: Adobe Heiti Std R;
		.mainbox{
			flex-direction: row;
			justify-content: space-between;
			.column{
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				width: 94%;
				float: left;
				padding-top: 20px;
				padding-left: 3%;
				padding-right: 3%;
				background-color: #98273A;
				height: 65px;
				.title{
					margin-bottom: 10px;
					font-size: 18px;
					line-height: 27px;
				}
				.link{
					margin-bottom: 5px;
				}
			}
			.qrcode{
				width: 100%;
				padding-top: 100px;
				height: 150px;
				background-color: #98273A;
				img{
					width: 100px;
					height: 100px;
					margin: 0px 0 0 10px;
					margin-left: 5%;
				}
				div{
					width: 140px;
					text-align: center;
				};
			}
		}
		.tipbox{
			width: 100%;
			height: 110px;
			text-align: center;
			background-color: #202020;
			color: #8D8D8D;
			padding-top: 20px;
			.block{
				display: inline-block;
				width: 200px;
			}
			span{
				display: inline-block;
			};
		}
	}
</style>
